package meineglasfaser.frontend.www

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.App
import meineglasfaser.frontend.common.PromKobwebApp
import meineglasfaser.frontend.www.components.ProvideCustomerState
import meineglasfaser.frontend.www.components.ProvideShopBasketState

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    PromKobwebApp {
        ProvideShopBasketState()
        ProvideCustomerState {
            content()
        }
    }
}
